import { createContext, Dispatch, SetStateAction } from 'react';

import { UseEQLFilterValues } from './types';

export const EQLFilterContext = createContext<
  [boolean, Dispatch<SetStateAction<boolean>>]
>([false, () => {}]);

export const EQLFilterValuesContext = createContext<
  UseEQLFilterValues | undefined
>(undefined);
